export const DEFAULT_ADDRESS_FORM_VALUES = {
  addressAutocomplete: '',
  banId: '',
  'search-addressAutocomplete': '',
  city: '',
  latitude: 0,
  longitude: 0,
  street: '',
  postalCode: '',
  inseeCode: '',
  coords: '',
  manuallySetAddress: false,
}

export const DEBOUNCE_TIME_BEFORE_REQUEST = 400
export const DEFAULT_SUGGESTION_LIMIT = 5
